import React from "react"
import styled from "styled-components"

import Icon from "../global/icon"

const ArticleDisclosureWrapper = styled.div`
  display: flex;
  align-items: center;
  svg {
    min-width: 24px;
    width: 24px;
    height: 24px;
    stroke: #4a5568;
  }
`
const Disclosure = styled.div`
  padding-left: 16px;
  margin-left: 16px;
  border-left: 1px solid #4a5568;
  color: #4a5568 !important;
  font-size: 12px;
  line-height: 16px;

  p {
    color: #4a5568 !important;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 0;
  }
  a {
    color: #4082c4;
    :hover {
      text-decoration: underline;
    }
  }
`

const ArticleDisclosure = props => {
  return (
    <ArticleDisclosureWrapper
      className={props.className ? props.className : ""}
    >
      <Icon icon="info" />
      {typeof props.disclosure === "string" ? (
        <Disclosure
          dangerouslySetInnerHTML={{
            __html: props.disclosure,
          }}
        />
      ) : (
        <Disclosure>{props.disclosure}</Disclosure>
      )}
    </ArticleDisclosureWrapper>
  )
}

export default ArticleDisclosure
